export class AddPropertyToDomainRequest {
   addAllTaskTemplates: boolean = true;
   copyAiConfig: boolean = false;
   addAutoRunSchedules: boolean = true;
}
